<template>
    <span class="contact-photo"
          :style="style"></span>
</template>

<script>
import { container } from '@/container';

export default {
    props: {
        /**
         * @type {Contact}
         */
        contact: {
            type: Object,
            required: true,
        },

        /**
         * @type {number}
         */
        width: {
            type: Number,
            default: 600,
        },

        /**
         * @type {number}
         */
        height: {
            type: Number,
            default: 450,
        },
    },

    computed: {
        style() {
            return {
                'background-image': `url(${this.src})`,
            };
        },

        alt() {
            if (this.src) {
                return `No photo of ${this.contact.name} is available`;
            }

            return `Photo of ${this.contact.name}`;
        },

        src() {
            const appConfig = container.appConfig;

            const contactPhotoData = this.contact.photoData;
            if (contactPhotoData) {
                // photoData is a base64 encoded image.
                return contactPhotoData;
            }

            const contactPhotoPath = this.contact.getPhotoPath(this.width, this.height);
            if (contactPhotoPath) {
                // contactPhotoPath is a relative path to the image.
                return appConfig.appUrl + contactPhotoPath;
            }

            // Default image.
            return '/epos/img/default-member-photo.jpg';
        },
    },
};
</script>

<style lang="less">
@import "../../../../less/variables";

.contact-photo {
    display: inline-block;

    // Same colour as the grey bg in the silhouette default image.
    background: @mid-grey-alt no-repeat center center;
    background-size: cover;
}
</style>
